import styled from 'styled-components/macro';
import classNames from "classnames";
import NavLink from "../nav_link";
import {useActions, useLoggedIn, useModal, useSettings} from "../../store";
import truncateNumber from "../../utils/score_truncate";
import Signup from "../signup";
import Login from "../login";
import SaveFolders from "../save_folders";
import CreatePost from "../create_post";
import {useHistory} from "react-router-dom";
import {useFeedback} from "../../store/feedback";
import useLogout from "../../api/logout";
import {themecolors} from "../../utils/themecolors";
import {Bell, LogOut, Settings as LucideSettings} from "lucide-react";

const Item = styled.div``;
const Inner = styled.div``;
const Account = styled.div``;
const AccountInner = styled.div``;
const SortOptions = styled.div``;
const Unread = styled.div``;
const BarButton = styled.div``;
const Separator = styled.div``;

const Settings = styled.div``;

const AuthText = styled.span`
  cursor: pointer;
`;
const SettingsMenu = styled.div``;
const SettingsItem = styled.div``;

const LegacySortBar = styled(({className, refresh}) => {
    const loggedIn = useLoggedIn();
    const {username, post_score, comment_score, unread} = useSettings();
    const truncatedPostScore = truncateNumber(post_score);
    const truncatedCommentScore = truncateNumber(comment_score);

    const modal = useModal();
    const handleSignup = () => {
        modal.open(Signup);
    };
    const handleLogin = () => {
        modal.open(Login);
    };

    const actions = useActions();
    const onClick = () => {
        actions.lastFeedPosChanged("", 0);
        actions.feedLoadResetAll();
    };

    const {feedbackCh} = useFeedback(true);
    const logout = useLogout(feedbackCh);
    const history = useHistory();
    const handleLogout = async () => {
        try {
            await logout();
            history.replace('/');
        } catch {
        }
    };

    return (
        <div className={classNames(className, 'legacy-sort-bar')}>
            <Inner>
                <div />
                <SortOptions>
                    <NavLink href={`/`} react_route activeOnlyWhenExact onRefresh={refresh} onClick={onClick}>
                        <Item>
                            Hot
                        </Item>
                    </NavLink>
                    <NavLink href={`/new`} react_route onRefresh={refresh} onClick={onClick}>
                        <Item>
                            New
                        </Item>
                    </NavLink>
                    <NavLink href={`/active`} react_route onRefresh={refresh} onClick={onClick}>
                        <Item>
                            Active
                        </Item>
                    </NavLink>
                    <NavLink href={`/rising`} react_route onRefresh={refresh} onClick={onClick}>
                        <Item>
                            Rising
                        </Item>
                    </NavLink>
                    <NavLink href={`/top`} react_route onRefresh={refresh} onClick={onClick}>
                        <Item>
                            Top
                        </Item>
                    </NavLink>
                </SortOptions>
                <Account>
                    {loggedIn ?
                        <AccountInner>
                            <NavLink href={'/u/me'} react_route>
                                {username}
                            </NavLink>
                            {` (${truncatedPostScore}`}
                            <Separator>•</Separator>
                            {truncatedCommentScore})
                            <Separator>•</Separator>

                            <NavLink href={`/messages${unread > 0 ? '?type=unread' : ''}`} react_route>
                                <BarButton>
                                    {unread > 0 && <Unread>{unread > 99 ? 99 : unread}</Unread>}
                                    <Bell size={18} />
                                </BarButton>
                            </NavLink>
                            <Separator>•</Separator>
                            <Settings>
                                <BarButton>
                                    <LucideSettings size={18} />
                                </BarButton>
                                <SettingsMenu>
                                    <SettingsItem onClick={() => modal.open(CreatePost, {community: "TheDonald"})}>Create a Post</SettingsItem>
                                    <SettingsItem onClick={() => modal.open(SaveFolders)}>Saved Posts</SettingsItem>
                                    <NavLink href={"/upvoted"} react_route>
                                        <SettingsItem>Upvoted Posts</SettingsItem>
                                    </NavLink>
                                    <NavLink href={"/hidden"} react_route>
                                        <SettingsItem>Hidden Posts</SettingsItem>
                                    </NavLink>
                                    <NavLink href={"/settings"} react_route>
                                        <SettingsItem>Settings</SettingsItem>
                                    </NavLink>
                                    <SettingsItem onClick={handleLogout}>Logout</SettingsItem>
                                </SettingsMenu>
                            </Settings>
                            <Separator>•</Separator>
                                <BarButton onClick={handleLogout}>
                                    <LogOut size={18} />
                                </BarButton>

                        </AccountInner>
                        :
                        <AccountInner>
                            <AuthText onClick={handleLogin}>Login</AuthText> or <AuthText onClick={handleSignup}>create an account</AuthText>
                        </AccountInner>
                    }
                </Account>
            </Inner>
        </div>
    );
})`
  background: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  margin-bottom: 8px;
  background: url("https://img.patriots.win/thedonald/community/bg-nav.png");
  border-bottom: 3px solid #b30000;
  box-shadow: 0 5px 5px -2px rgba(0,0,0,.3);

  ${Settings} {
    cursor: pointer;
  }
  ${Settings}:hover ${SettingsMenu} {
    display: initial;
  }
  ${SettingsMenu} {
    display: none;
    position: absolute;
    width: 160px;
    margin-left: -80px;
    background-color: #b30400;
    border-radius: 4px;
    padding: 8px;
    z-index: 1;
  }
  ${SettingsItem} {
    text-align: center;
    padding: 4px;
  }
  ${Inner} > * {
    flex-basis: 33.33%;
  }
  ${Separator} {
    margin: 0 3px;
  }
  ${BarButton} {
    display: flex;
    padding: 4px;
    cursor: pointer;
  }
  ${Unread} {
    color: white;
    background-color: #2e325f;
    font-size: 11px;
    border-radius: 50%;
    height: 18px;
    width: 18px;
    position: absolute;
    margin-top: -8px;
    margin-left: 9px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${SortOptions} {
    margin-top: 2px;
    white-space: nowrap;
    flex-wrap: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${Item} {
    font-size: 15px;
    padding: 0 20px;
    height: 41px;
    padding-top: 2px;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-transform: uppercase;
    color: #fff;
  }
  
  a.active {
    background-color: #b30000;
  }
  ${Item}:hover {
    background-color: #fff;
    color: #000;
  }
  
  ${Inner} {
    max-width: ${({theme}) => theme.fullWidth ? '100%' : '1360px'};
    margin: 0 auto;
    flex: 0 0 41px;
    display: flex;
    align-items: center;
    height: 41px;
  }
  
  ${Account} {
    margin-top: 2px;
    margin-left: auto;
  }
  
  ${AccountInner} {
    height: 41px;
    margin-left: auto;
    text-shadow: 0 0 3px #111;
    padding: 0 12px;
    font-size: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #b30000;
    width: 316px;
    white-space: pre;
  }
  
  @media only screen and (min-width: 781px) {
    &.mobile {
      display: none;
    }
  }
  @media only screen and (max-width: 780px) {
    & {
      display: none;
    }
  }
`;
export default LegacySortBar;